import React from "react";
import { Input } from "antd";

import "./styles.css";
import { cn } from "utils/cn";

const { Search: AntdSearch } = Input;

function Search({
  className,
  containerClassName,
  allowClear = true,
  placeholder = "Search by keyword",
  enterButton = true,
  ...props
}) {
  return (
    <div className={cn("search-input-wrapper rounded-[20px]", containerClassName)}>
      <AntdSearch
        className={className}
        allowClear={allowClear}
        placeholder={placeholder}
        enterButton={enterButton}
        {...props}
      />
    </div>
  );
}

export { Search };
